import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, logout as apiLogout, demoLogin as apiDemoLogin, getMe } from '../api/client';
import api from '../api/client';

const AuthContext = createContext(null);
const TOKEN_KEY = 'gm_authtoken';
const DEMO_KEY  = 'gm_is_demo';

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDemo, setIsDemo]   = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(TOKEN_KEY);
    if (!saved) {
      // No token at all — skip the /me call entirely
      setLoading(false);
      return;
    }
    // Attach header BEFORE making any request
    api.defaults.headers.common['Authorization'] = `Token ${saved}`;

    getMe()
      .then(r => {
        setUser(r.data);
        setIsDemo(!!localStorage.getItem(DEMO_KEY));
      })
      .catch(() => {
        setUser(null);
        setIsDemo(false);
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(DEMO_KEY);
        delete api.defaults.headers.common['Authorization'];
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await apiLogin({ username, password });
    const token = res.data.token;
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.removeItem(DEMO_KEY);
      api.defaults.headers.common['Authorization'] = `Token ${token}`;
    }
    setIsDemo(false);
    setUser(res.data.user);
    return res.data.user;
  };

  const loginAsDemo = async () => {
    const res = await apiDemoLogin();
    const token = res.data.token;
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(DEMO_KEY, '1');
      api.defaults.headers.common['Authorization'] = `Token ${token}`;
    }
    setIsDemo(true);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try { await apiLogout(); } catch {}
    setUser(null);
    setIsDemo(false);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(DEMO_KEY);
    delete api.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ user, login, loginAsDemo, logout, loading, isDemo }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);